"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  ThemeProvider: true,
  ThemeConsumer: true,
  ThemeContext: true,
  defaultTheme: true,
  useTheme: true,
  enableBodyScroll: true,
  disableBodyScroll: true
};
exports.useTheme = exports.enableBodyScroll = exports.disableBodyScroll = exports.defaultTheme = exports.ThemeProvider = exports.ThemeContext = exports.ThemeConsumer = void 0;
var _themeProvider = _interopRequireWildcard(require("./components/theme-provider"));
exports.ThemeProvider = _themeProvider["default"];
exports.enableBodyScroll = _themeProvider.enableBodyScroll;
exports.disableBodyScroll = _themeProvider.disableBodyScroll;
var _themeConsumer = _interopRequireDefault(require("./components/theme-consumer"));
exports.ThemeConsumer = _themeConsumer["default"];
var _themeContext = _interopRequireDefault(require("./context/theme-context"));
exports.ThemeContext = _themeContext["default"];
var _theme = _interopRequireDefault(require("./themes/theme.css"));
exports.defaultTheme = _theme["default"];
var _useTheme = _interopRequireDefault(require("./hooks/useTheme"));
exports.useTheme = _useTheme["default"];
var _themeIcons = require("./theme-icons");
Object.keys(_themeIcons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _themeIcons[key]) return;
  exports[key] = _themeIcons[key];
});
var _theme2 = require("./theme.config");
Object.keys(_theme2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _theme2[key]) return;
  exports[key] = _theme2[key];
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }